import React from "react"
import { Grid, Divider } from "@material-ui/core"
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui"
import { TYPE_INSTANCE2 } from "App/constants"
import { useSelectOption } from "App/hooks"
import {
  filterStatusPembayaran,
  getByFilterTagihanExport,
  RESET_STATE_FORM_FILTER,
} from "./helpers"

import { useState } from "react"
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"
import ListTotalTagihan from "./ListTotalTagihan"
import { useSelector } from "react-redux"

export default function FormFilterDaftarPenjualan({
  formFilter,
  setFormFilter,
  setNewData,
  withExportButton = false,
  data,
  resetPagination,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [showModalExportList, setShowModalExportList] = useState(false)
  const master = useSelector(({ master }) => master)
  const handleChange = (text) => (e) => {
    if (text === "kategori_pencarian") {
      if (e.target.value === "0" || e.target.value === 0) {
        return setFormFilter({
          ...formFilter,
          kata_kunci: "",
          [text]: e.target.value,
        })
      }
    }

    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    await setNewData(1, 10)
    resetPagination()
  }

  const asuransi = useSelectOption(true, "/insurance/list_prm", TYPE_INSTANCE2)
  const jenisLayanan = useSelectOption(
    true,
    "/jenis_layanan/listjenis_layanan",
    TYPE_INSTANCE2,
  )

  const handleExport = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const res = await getByFilterTagihanExport(formFilter)
      if (res.state) {
        defaultToastSuccess("Berhasil, mohon menunggu data sedang dieksport...")
      } else {
        defaultToastError(res.message)
      }

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      defaultToastError(error?.response?.data?.message)
    }
  }

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={7}>
            <Grid container spacing={1}>
              <Grid item sm={3}>
                <InputOptionMaster
                  name="kategori_pencarian"
                  label="KATEGORI PENCARIAN"
                  id="kategori_pencarian"
                  withSearch={false}
                  value={formFilter.kategori_pencarian}
                  onChange={handleChange("kategori_pencarian")}
                  data={[
                    {
                      value: 0,
                      label: "Semua",
                    },
                    {
                      value: 1,
                      label: "ID Tagihan",
                    },
                    {
                      value: 2,
                      label: "ID RM",
                    },
                    {
                      value: 3,
                      label: "Nama RM",
                    },
                    {
                      value: 4,
                      label: "ID Rekap Tagihan",
                    },
                  ]}
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name="kata_kunci"
                  label="KATA KUNCI"
                  id="kata_kunci"
                  value={formFilter.kata_kunci}
                  onChange={handleChange("kata_kunci")}
                  placeholder="KATA KUNCI"
                  disabled={
                    formFilter.kategori_pencarian === 0 ||
                    formFilter.kategori_pencarian === "0"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid item sm={3}>
                <InputOptionMaster
                  name="asuransi_id"
                  label="ASURANSI"
                  id="asuransi_id"
                  withSearch={true}
                  data={asuransi}
                  value={formFilter.asuransi_id}
                  labelValue={formFilter.asuransi_name}
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      asuransi_id: e?.value,
                      asuransi_name: e?.label,
                    })
                  }
                />
              </Grid>

              <Grid item sm={3}>
                <InputOptionMaster
                  name="jenis_layanan_id"
                  label="JENIS LAYANAN"
                  id="jenis_layanan_id"
                  withSearch={true}
                  data={jenisLayanan}
                  value={formFilter.jenis_layanan_id}
                  labelValue={formFilter.jenis_layanan_name}
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      jenis_layanan_id: e?.value,
                      jenis_layanan_name: e?.label,
                    })
                  }
                />
              </Grid>
              <Grid item sm={3}>
                <InputOptionMaster
                  name="status_pembayaran"
                  label="STATUS PEMBAYARAN"
                  id="status_pembayaran"
                  withSearch={true}
                  data={filterStatusPembayaran}
                  value={formFilter.status_pembayaran}
                  labelValue={formFilter.status_pembayaran_name}
                  onChange={(e) =>
                    !isNull(e)
                      ? setFormFilter({
                          ...formFilter,
                          status_pembayaran: e?.value,
                          status_pembayaran_name: e?.label,
                        })
                      : setFormFilter({
                          ...formFilter,
                          status_pembayaran: "",
                          status_pembayaran_name: "Pilih Status Pembayaran",
                        })
                  }
                />
              </Grid>
              <Grid item md={3}>
                <InputOptionMaster
                  name="company_id"
                  label="PERUSAHAAN"
                  id="company_id"
                  withSearch={true}
                  data={master.perusahaan.list_select}
                  value={formFilter.company_id}
                  labelValue={formFilter.company_name}
                  // error={true}
                  // message={messageError.required}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormFilter({
                        ...formFilter,
                        company_id: null,
                        company_name: "Pilih Perusahaan",
                      })
                    } else {
                      setFormFilter({
                        ...formFilter,
                        company_id: e.value,
                        company_name: e.label,
                      })
                    }
                  }}
                />
              </Grid>

              <Grid item sm={6}>
                <InputReactDatepicker
                  isClearable={true}
                  selected={formFilter.tanggal_awal}
                  label="TANGGAL"
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                  withToday={true}
                  onChange={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                  withPeriode={true}
                >
                  <button
                    type={"button"}
                    onClick={null}
                    style={{
                      borderLeft: "1px solid #EAEAEA",
                      borderTop: "1px solid #EAEAEA",
                      borderBottom: "1px solid #EAEAEA",
                      borderRight: "1px solid #EAEAEA",
                      background: "#fff",
                      padding: "0 0.8rem 0 0.8rem",
                      cursor: "pointer",
                      // borderRadius: "6px 0 0 6px",
                      fontSize: "10px",
                    }}
                  >
                    s/d
                  </button>
                  <InputReactDatepicker
                    isClearable={true}
                    selected={formFilter.tanggal_akhir}
                    label=""
                    withToday={true}
                    handleChangeToday={(e) =>
                      setFormFilter({
                        ...formFilter,
                        tanggal_akhir: e,
                      })
                    }
                    onChange={(e) =>
                      setFormFilter({
                        ...formFilter,
                        tanggal_akhir: e,
                      })
                    }
                    withParentPeriode={true}
                  />
                </InputReactDatepicker>
              </Grid>
            </Grid>
          </Grid>

          <Grid item sm={5}>
            <ListTotalTagihan data={data} />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />

          <div style={{ display: "flex", gap: 16 }}>
            {withExportButton && (
              <>
                <MasterButton
                  type={"button"}
                  color="primary-cyan"
                  name={"Export List"}
                  size="md"
                  onClick={() => setShowModalExportList(!showModalExportList)}
                />

                <MasterButton
                  type={"button"}
                  color="warning"
                  name={isLoading ? "Loading..." : "EXPORT"}
                  disabled={isLoading}
                  size="md"
                  onClick={handleExport}
                />
              </>
            )}

            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              type={"submit"}
              size={"md"}
            />
          </div>
        </Grid>
        <br />
      </form>
      <Divider />

      {showModalExportList && (
        <ModalExportList
          title={"Export List Tagihan"}
          showModal={() => setShowModalExportList(false)}
          type="tagihan"
        />
      )}
    </>
  )
}
